'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * show the element only in print mode.
 *
 * This directive act as a ng-if="printMode==true" directive
 */
ngModule.directive("printOnly", function ($print, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var transcludedElement, transcludeScope;
      $scope.$watch(function () {
        return $print.isPrintEnabled();
      }, function (printEnabled) {
        if (printEnabled) {
          if (transcludeScope == null) {
            transcludeScope = $scope.$new();
            $transclude(transcludeScope, function (clone) {
              transcludedElement = clone;
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        } else {
          if (transcludeScope) {
            transcludeScope.$destroy();
            transcludeScope = null;
          }
          if (transcludedElement) {
            transcludedElement.remove();
            transcludedElement = null;
          }
        }
      });
    }
  };
});

/**
 * show the element only in print mode.
 *
 * This directive act as a ng-if="printMode==true" directive
 */
ngModule.directive("noPrint", function ($print, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var transcludedElement, transcludeScope;
      $scope.$watch(function () {
        return $print.isPrintEnabled();
      }, function (printEnabled) {
        if (!printEnabled) {
          if (transcludeScope == null) {
            transcludeScope = $scope.$new();
            $transclude(transcludeScope, function (clone) {
              transcludedElement = clone;
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        } else {
          if (transcludeScope) {
            transcludeScope.$destroy();
            transcludeScope = null;
          }
          if (transcludedElement) {
            transcludedElement.remove();
            transcludedElement = null;
          }
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/print/printOnly.js
// module id = 2718
// module chunks = 13